import * as actions from 'actions';
import pagingMaker from 'reducersMakers/pagingMaker';
import byKeyMaker from 'reducersMakers/byKeyMaker';

export default byKeyMaker('forumThreadsQueryString',
  pagingMaker({
    fetchType: actions.FORUM_THREADS_FETCH,
    fetchSuccessType: actions.FORUM_THREADS_FETCH_SUCCESS,
    fetchErrorType: actions.FORUM_THREADS_FETCH_ERROR,
    possiblePageUpdateType: actions.FORUM_THREADS_UPDATE_POSSIBLE_PAGE
  })
);



/** WEBPACK FOOTER **
 ** ./src/members/state/forum/paging/forumThreads/byQuery/reducer.js
 **/